
import * as Leaflet from 'leaflet';
import { useMap } from 'react-leaflet';
import { useEffect } from 'react';


export default function MapInitializer({
  mapWidth,
  mapHeight,
  zoomProjectionMargin,
  onMapReady,
}: {
  mapWidth: number;
  mapHeight: number;
  zoomProjectionMargin: number;
  onMapReady: (map: any, bounds: Leaflet.LatLngBounds, zoomArg: number) => void;
}) {
  const map = useMap();
  useEffect(() => {
    if (!map) return;

    if (!mapWidth || !mapHeight) {
      console.error('MapInitializer: invalid mapWidth/mapHeight', { mapWidth, mapHeight });
      return;
    }

    const containerRect = map.getContainer().getBoundingClientRect();
    const wHei = containerRect.height || window.innerHeight * 0.55;
    const wWidth = containerRect.width || window.innerWidth * 0.85;

    if (wHei <= 0 || wWidth <= 0) {
      console.error('MapInitializer: container has zero size', { wHei, wWidth });
      return;
    }

    const neededRescalingWidth = wWidth / mapWidth;
    const neededRescalingHeight = wHei / mapHeight;
    const neededRescaling = Math.min(neededRescalingHeight, neededRescalingWidth);

    if (!isFinite(neededRescaling) || neededRescaling <= 0) {
      console.error('MapInitializer: invalid neededRescaling', { neededRescaling, wHei, wWidth, mapWidth, mapHeight });
      return;
    }

    const zoomShift = Math.log2(neededRescaling);
    const zoomArg = -zoomShift + zoomProjectionMargin;

    const southWest = map.unproject([0, mapHeight], zoomArg);
    const northEast = map.unproject([mapWidth, 0], zoomArg);
    const computedBounds = Leaflet.latLngBounds(southWest, northEast);

    try {
      map.fitBounds(computedBounds, { padding: [15, 15], maxZoom: 5, animate: false });
    } catch (e) {
      console.debug('fitBounds during init failed', e);
    }

    onMapReady(map, computedBounds, zoomArg);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map, mapWidth, mapHeight, zoomProjectionMargin]);

  return null;
}